import { FormControl, TextField } from '@mui/material';
import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { BorderedInputAdornment } from '~/modules/@shared/components';
import { TakePaymentFormData } from '~/modules/payment/components/TakePayment/helpers/TakePaymentSchema';
import useGetSalesTax from '../../../../../../../../hooks/useGetSalesTax';
import { roundNumber } from '~/modules/@shared/helpers/roundNumber';

export default function PaymentTotalField() {
  const { watch } = useFormContext<TakePaymentFormData>();
  const { salesTax } = useGetSalesTax();

  const taxable = watch('taxable');
  const amount = watch('amount');

  const total = useMemo(() => {
    const subTotal = Number(amount ?? 0);
    const taxFactor = taxable ? salesTax / 100 : 0;
    const tax = subTotal * taxFactor;
    const localTotal = subTotal + tax;

    return roundNumber({ value: localTotal, decimals: 2 });
  }, [taxable, amount, salesTax]);

  return (
    <FormControl fullWidth>
      <TextField
        value={total}
        disabled
        InputProps={{
          startAdornment: <BorderedInputAdornment position="start">$</BorderedInputAdornment>,
          inputProps: {
            min: 0,
          },
        }}
      />
    </FormControl>
  );
}
